<template>
  <footer class="app-footer">
    <span><a v-bind:href="$t('COMPANYURL')">{{$t('COMPANYNAMEFOOTER')}}</a> {{$t('COPYRIGHTINFO')}}</span>
    <span class="ml-auto">{{$t('POWEREDBY')}} <a v-bind:href="$t('COREAPPSURL')">{{$t('COREAPSNAME')}}</a></span>
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>
